import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import MasterBarangPage from "@/pages/MasterBarangPage";
import MasterKategoriPage from "@/pages/MasterKategoriPage";
import MasterSupplierPage from "@/pages/MasterSupplierPage";
import BarangMasukPage from "@/pages/BarangMasukPage";
import BarangKeluarPage from "@/pages/BarangKeluarPage";
import ModalPage from "@/pages/ModalPage";
import LaporanPage from "@/pages/LaporanPage";
import LaporanBarangKeluarPage from "@/pages/LaporanBarangKeluarPage";
import UserManagementPage from "@/pages/UserManagementPage";
import PemesananPage from "@/pages/PemesananPage";
import ProfilePage from "@/pages/ProfilePage";
import RabPage from "@/pages/RabPage";
import Layout from "@/components/Layout";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import PrivateRoute from "@/components/PrivateRoute";
import RoleRoute from "@/components/RoleRoute";
import {
  BARANG_KELUAR_ROLES,
  MANAGEMENT_ROLES,
  MODAL_PAGE_ROLES,
  REPORT_PAGE_ROLES,
  ROLE_KEPALA_RUANGAN,
  SUPPLIER_PAGE_ROLES,
  getDefaultRouteForRole,
} from "@/lib/roles";

const DefaultIndexRoute = () => {
  const { user } = useAuth();

  return <Navigate to={getDefaultRouteForRole(user?.role)} replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<DefaultIndexRoute />} />
            <Route path="dashboard" element={<RoleRoute roles={[ROLE_KEPALA_RUANGAN]}><DashboardPage /></RoleRoute>} />
            <Route path="master-barang" element={<RoleRoute roles={MANAGEMENT_ROLES}><MasterBarangPage /></RoleRoute>} />
            <Route path="master-kategori" element={<RoleRoute roles={[ROLE_KEPALA_RUANGAN]}><MasterKategoriPage /></RoleRoute>} />
            <Route path="master-supplier" element={<RoleRoute roles={SUPPLIER_PAGE_ROLES}><MasterSupplierPage /></RoleRoute>} />
            <Route path="barang-masuk" element={<RoleRoute roles={MANAGEMENT_ROLES}><BarangMasukPage /></RoleRoute>} />
            <Route path="barang-keluar" element={<RoleRoute roles={BARANG_KELUAR_ROLES}><BarangKeluarPage /></RoleRoute>} />
            <Route path="pemesanan" element={<RoleRoute roles={MANAGEMENT_ROLES}><PemesananPage /></RoleRoute>} />
            <Route path="modal" element={<RoleRoute roles={MODAL_PAGE_ROLES}><ModalPage /></RoleRoute>} />
            <Route path="laporan" element={<RoleRoute roles={REPORT_PAGE_ROLES}><LaporanPage /></RoleRoute>} />
            <Route path="laporan/barang-keluar" element={<RoleRoute roles={REPORT_PAGE_ROLES}><LaporanBarangKeluarPage /></RoleRoute>} />
            <Route path="user-management" element={<RoleRoute roles={[ROLE_KEPALA_RUANGAN]}><UserManagementPage /></RoleRoute>} />
            <Route path="profile" element={<RoleRoute roles={MANAGEMENT_ROLES}><ProfilePage /></RoleRoute>} />
            <Route path="rab" element={<RoleRoute roles={MANAGEMENT_ROLES}><RabPage /></RoleRoute>} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
